import { useState } from 'react';
import { Trash2 } from 'lucide-react';
import { useNavigate } from 'react-router';

import { Button } from '@/components/ui/button';
import { RemoveDialog } from 'src/containers/Escrow/Remove';
import { useSaasEscrow } from 'src/context/saas-escrow';

const RemoveAction = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const {
    saasEscrow: { id, app },
  } = useSaasEscrow();

  const onClose = () => setIsOpen(false);

  const onOpen = () => setIsOpen(true);

  const onSuccess = () => navigate(`/applications/${app.id}`);

  return (
    <RemoveDialog
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      successCallback={onSuccess}
      escrowId={id}
      triggerNode={
        <Button variant="destructive">
          <Trash2 /> Delete escrow
        </Button>
      }
    />
  );
};

export default RemoveAction;
